var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"four"},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("找不到页面拉")]),_c('router-link',{attrs:{"to":"home"}},[_vm._v("返回主页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }